import axios from 'axios';

const api = axios.create({
  baseURL: '/projects/data/'
});

export const getProjectsList = async () => {
  return api.get('list.json');
};

export const getProject = async slug => {
  return api.get(`${slug}.json`);
};

export const getModernitska = () => {
  return api.get(`modernitska.json`);
};
